import { Fragment } from "react";
import type { TextBlock } from "@/lib/posting";

/**
 * A posting's text, in its headings, paragraphs, lists and labels. Its
 * parent sets the type and the gaps; `Heading` keeps the outline right
 * under whatever heading sits above.
 */
export default function PostingBlocks({
    blocks,
    Heading,
    headingClassName,
}: {
    blocks: TextBlock[];
    Heading: "h3" | "h4";
    headingClassName: string;
}) {
    return blocks.map((block, index) =>
        block.kind === "heading" ? (
            <Heading key={index} className={headingClassName}>
                {block.text}
            </Heading>
        ) : block.kind === "list" ? (
            <ul key={index} className="m-0 flex list-disc flex-col gap-1.5 pl-5">
                {block.items.map((item, at) => (
                    <li key={at}>{item}</li>
                ))}
            </ul>
        ) : block.kind === "field" ? (
            <p key={index} data-field className="m-0">
                <span className="font-semibold text-fg">{block.label}</span> {block.value}
            </p>
        ) : (
            <p key={index} className="m-0">
                {block.lines.map((line, at) => (
                    <Fragment key={at}>
                        {at > 0 && <br />}
                        {line}
                    </Fragment>
                ))}
            </p>
        ),
    );
}
